/* Búsqueda HerBalance — generado por paginas-v2/construir_shopify.py.
   Shopify busca producto, páginas y artículos. Aquí solo se filtran las preguntas frecuentes (lista fija de la sección)
   con lo que se buscó: sin tildes, plurales simples y un error de una letra. Si alguna coincide, se muestran. */
(() => {
  const s = document.getElementById('resultados');
  const faq = document.getElementById('b-faq');
  if (!s || !faq) return;
  const q = (s.dataset.terminos || '').trim();
  if (!q) return;

  const norm = t => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const palabras = t => norm(t).split(/[^a-z0-9]+/).filter(Boolean);
  const PARADAS = new Set('a al como con de del el en es esta este la las le les lo los me mi mis o para por que se si su sus te tu tus un una unas unos y ya'.split(' '));
  const ts = palabras(q).filter(w => w.length > 1 && !PARADAS.has(w));
  if (!ts.length) return;
  const raiz = w => (w.length > 5 && w.endsWith('es')) ? w.slice(0, -2) : (w.length > 4 && w.endsWith('s')) ? w.slice(0, -1) : w;
  const casi = (a, b) => {
    if (a === b) return true;
    if (Math.abs(a.length - b.length) > 1) return false;
    if (a.length === b.length) {
      const d = [];
      for (let i = 0; i < a.length && d.length < 3; i++) if (a[i] !== b[i]) d.push(i);
      return d.length === 1 || (d.length === 2 && d[1] === d[0] + 1 && a[d[0]] === b[d[1]] && a[d[1]] === b[d[0]]);
    }
    const [c, l] = a.length < b.length ? [a, b] : [b, a];
    let i = 0, j = 0, saltos = 0;
    while (i < c.length && j < l.length) { if (c[i] === l[j]) { i++; j++; } else { if (++saltos > 1) return false; j++; } }
    return true;
  };
  const parecida = (t, w) => raiz(w) === raiz(t) || (t.length >= 5 && w.length >= 4 && casi(raiz(t), raiz(w)));
  const coincide = (t, w) => w.startsWith(t) || parecida(t, w);

  const items = [...faq.querySelectorAll('details[data-claves]')];
  const puntaje = el => {
    const titulo = palabras(el.querySelector('summary').textContent), claves = palabras(el.dataset.claves), texto = palabras(el.textContent);
    let total = 0;
    for (const t of ts) {
      const p = titulo.some(w => coincide(t, w)) ? 3 : claves.some(w => coincide(t, w)) ? 2 : texto.some(w => parecida(t, w)) ? 1 : 0;
      if (!p) return 0;
      total += p;
    }
    return total;
  };
  const lista = faq.querySelector('[data-lista]');
  const visibles = items.map(el => ({ el, p: puntaje(el) })).filter(x => x.p > 0).sort((a, b) => b.p - a.p);
  items.forEach(el => { el.hidden = true; el.open = false; });
  visibles.forEach(x => { x.el.hidden = false; lista.append(x.el); });
  if (!visibles.length) return;
  visibles[0].el.open = true;
  faq.hidden = false;
  document.getElementById('b-faq-cuenta').textContent = visibles.length;

  // Si Shopify no trajo nada pero sí hay preguntas que coinciden, se muestran en vez del «no encontramos».
  const res = document.getElementById('b-resultados');
  const vacio = document.getElementById('b-vacio');
  const resumen = document.getElementById('b-resumen');
  res.hidden = false;
  if (vacio && !vacio.hidden) {
    vacio.hidden = true;
    if (resumen) resumen.innerHTML = `${visibles.length} ${visibles.length === 1 ? 'pregunta' : 'preguntas'} para <b>“${q.replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))}”</b>`;
  } else if (resumen) {
    const n = Number((resumen.textContent.match(/^\d+/) || [0])[0]) + visibles.length;
    resumen.firstChild.textContent = `${n} ${n === 1 ? 'resultado' : 'resultados'} para `;
  }
})();
